import { OptionWithValuesMulti } from './option-with-values-mulit';

export class OptionMultiple extends OptionWithValuesMulti {
    readonly type = 'multiple';
}
